import Jumbotron from './Jumbotron/Jumbotron';
import Heading from './Heading/Heading';
import Tiles from './Tiles/Tiles';
import BlogPreview from './BlogPreview/BlogPreview';
import BlogPreviewList from './BlogPreview/BlogPreviewList';
import JumbotronCarousel from './JumbotronCarousel/JumbotronCarousel';

export default {
  jumbotron: {
    standard: Jumbotron
  },
  heading: {
    standard: Heading
  },
  'blog-preview': {
    block: BlogPreview,
    list: BlogPreviewList
  }
};
